import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';

import { Google, GoogleTransformers, Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';

const { inventoryTransformer: googleInventoryTransformer } = GoogleTransformers;

/**
 * @summary Sends GA360 and Pixall when clicking on view specs links
 */
export function inventoryViewSpecificationsClick(metadata, option) {
    const {
        data,
        dataLayer = {},
        state,
        event,
    } = metadata;

    const { inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const listingType = _get(inventory, 'listingType', '').toLowerCase();
    const {
        innerText,
        textContent,
        parentNode: {
            innerText: parentNodeInnerText,
        } = {},
    } = event?.target || {};
    const text = (innerText || textContent || parentNodeInnerText || '').trim();
    const gaEventData = {};
    let linkCopy = _kebabCase(text);
    let pixallLabel = 'view_feat_specf';
    let eventNonInteractive = false;

    if (text === 'See All Features') {
        linkCopy = 'view-all-features';
        pixallLabel = 'see_fts';
        eventNonInteractive = true;
    } else if (text === 'See All Features and Packages') {
        linkCopy = 'view-all-features-and-packages';
        pixallLabel = 'see_fts_pkgs';
        eventNonInteractive = true;
    } else {
        gaEventData.vehicle = googleInventoryTransformer(inventory, { target: 'vehicle', dataLayer });
    }

    Google.sendClickEvent({
        eventElement: `vdp_${listingType}`,
        eventResult: `text-link::${linkCopy}`,
        eventNonInteractive,
        eventData: gaEventData,
    }, option);

    Pixall.sendClickEvent({
        eventSource: 'vehicle',
        label: pixallLabel,
        inventory,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    return {};
}
